import { DocumentReference } from 'firebase/firestore';
import { type Property } from './property';
import { type FeatureOption, FeatureType } from './feature';

export interface HomeWorld {
	id: string;
	name: string;
	tag: string;
	description: string;
	imageURL: string;
	docURL: string;
	originId?: string; // Optional: link to parent origin
	propertyRefs: DocumentReference[];
	properties: Property[];
	createdAt?: number;
	updatedAt?: number;
}

export const getDefaultHomeWorld = (): HomeWorld => {
	return {
		id: '-1',
		name: '',
		tag: '',
		description: '',
		imageURL: '',
		docURL: '',
		originId: undefined,
		propertyRefs: [],
		properties: [],
		createdAt: Date.now(),
		updatedAt: Date.now(),
	};
};

export const homeWorld2FeatureOption = (homeWorld: HomeWorld): FeatureOption => {
	return {
		id: homeWorld.id,
		name: homeWorld.name,
		type: FeatureType.homeWorld,
		imageURL: homeWorld.imageURL,
		docURL: homeWorld.docURL,
		tag: homeWorld.tag,
		description: homeWorld.description,
		propertyRefs: homeWorld.propertyRefs,
	};
};

export const featureOption2HomeWorld = (featureOption: FeatureOption): HomeWorld => {
	return {
		id: featureOption.id,
		name: featureOption.name,
		tag: featureOption.tag,
		description: featureOption.description,
		imageURL: featureOption.imageURL,
		docURL: featureOption.docURL,
		propertyRefs: featureOption.propertyRefs,
		properties: [],
	};
};
